import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';

/**
 * Displays paging information for robots.
 *
 * @example
 *  <ish-product-list-paging *ngIf="displayPaging$ | async"
 *    [currentPage]="currentPage$ | async"
 *    [pageIndices]="pageIndices$ | async"
 *  ></ish-product-list-paging>
 */
@Component({
  selector: 'ish-product-list-paging',
  templateUrl: './product-list-paging.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule],
})
export class ProductListPagingComponent {
  readonly currentPage = input.required<number>();
  readonly pageIndices = input.required<
    {
      value: number;
      display: string;
    }[]
  >();
  readonly fragmentOnRouting = input<string>(undefined);
}
